import { getRegionConfig } from 'config';
import { type Locale } from 'config/constants/locales';
import { Region } from 'constants/shop';
import { getLocaleFromNextLocale } from 'utils/market';
import { syncApiInterceptor } from './api-interceptor';
import { getRegion } from 'utils/i18n/get-region';
import { isSupportedLocale } from 'utils/is-supported-locale';

const getInitialLocale = (region: Region): Locale => {
  const documentLocale = document.documentElement.lang;

  if (isSupportedLocale(documentLocale)) return documentLocale;

  return getLocaleFromNextLocale(
    region,
    typeof window !== 'undefined' ? window.__NEXT_DATA__?.locale : undefined
  );
};

export const initApiInterceptorFromDocument = (): void => {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  const region = getRegion(window.location.hostname);
  const locale = getInitialLocale(region) || getRegionConfig(region).locale;

  syncApiInterceptor(region, locale);
};

initApiInterceptorFromDocument();
